import React from 'react'
import { OffersBanner } from '@core/Areas/VenueMode/Components/Offers/OffersBanner'

export const OffersTab = (): React.JSX.Element => {
  return <OffersBanner />
}
